import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sheet" }
const _hoisted_2 = { class: "sheet-header" }
const _hoisted_3 = { class: "input-wrap" }
const _hoisted_4 = { class: "sheet-body" }

import { computed, ref, watch, nextTick } from 'vue';
import TrendingList from './TrendingList.vue';
import SuggestList from './SuggestList.vue';
import SearchService, { TypeaheadItem } from '@/services/SearchService';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchSheet',
  props: /*@__PURE__*/_mergeModels({
    initialQuery: {}
  }, {
    "open": { type: Boolean, ...{ default: false } },
    "openModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["close", "select-term"], ["update:open"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// v-model:open from parent
const openModel = _useModel<boolean>(__props, 'open');

const q = ref('');
const suggestions = ref<TypeaheadItem[]>([]);
const loading = ref(false);
const fieldRef = ref<any>(null); // Vuetify component instance exposes .focus()
let inflightId = 0;

// seed + focus whenever the sheet opens
watch(openModel, async (v) => {
    if (!v) return;
    // prefer payload from parent; fall back to previous q
    if (typeof props.initialQuery === 'string') q.value = props.initialQuery;
    await nextTick();
    fieldRef.value?.focus?.();
});

const qTrim = computed(() => q.value.trim().toLowerCase());

function inferKind(text: string): 'tag' | 'key' {
    return text.startsWith('#') ? 'tag' : 'key';
}

function submitCurrent() {
    const text = qTrim.value;
    if (!text) return;

    const first = suggestions.value[0];
    if (first) {
        emit('select-term', { type: first.kind, term: first.term });
        return;
    }
    const kind = inferKind(text);
    const term = kind === 'tag' ? text.replace(/^#/, '') : text;
    emit('select-term', { type: kind, term });
}

watch(
    qTrim,
    async (text) => {
        suggestions.value = [];
        if (!text) return;

        const thisId = ++inflightId;
        loading.value = true;
        try {
            const resp = await SearchService.typeahead(text, 12);
            if (thisId !== inflightId) return;

            const forceKind: 'tag' | 'key' | null = text.startsWith('#') ? 'tag' : null;
            suggestions.value = (resp.items || []).map((it) => ({
                kind: forceKind ?? it.kind,
                term: it.term,
                count: it.count,
                sample_thumb: it.sample_thumb,
                sample_route: it.sample_route,
            }));
        } finally {
            if (thisId === inflightId) loading.value = false;
        }
    },
    { immediate: false }
);

function onSelect(payload: { type: 'tag' | 'key'; term: string }) {
    emit('select-term', payload);
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_bottom_sheet = _resolveComponent("v-bottom-sheet")!

  return (_openBlock(), _createBlock(_component_v_bottom_sheet, {
    modelValue: openModel.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((openModel).value = $event)),
    "scroll-strategy": "none",
    class: "bottom-sheet-centered"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_text_field, {
              ref_key: "fieldRef",
              ref: fieldRef,
              modelValue: q.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((q).value = $event)),
              variant: "solo-filled",
              label: "Search tags & keywords",
              clearable: "",
              density: "comfortable",
              "hide-details": "",
              autofocus: "",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('close')), ["esc"])),
              onKeydown: _withKeys(_withModifiers(submitCurrent, ["prevent"]), ["enter"])
            }, null, 8, ["modelValue", "onKeydown"])
          ]),
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-close")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          (q.value.trim().length >= 2)
            ? (_openBlock(), _createBlock(SuggestList, {
                key: 0,
                q: q.value,
                onSelect: onSelect
              }, null, 8, ["q"]))
            : (_openBlock(), _createBlock(TrendingList, {
                key: 1,
                limit: 20,
                onSelect: onSelect
              }))
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})